import { render } from "./PaqueteCreate.vue?vue&type=template&id=f054cf2e&scoped=true"
import script from "./PaqueteCreate.vue?vue&type=script&lang=js"
export * from "./PaqueteCreate.vue?vue&type=script&lang=js"

import "./PaqueteCreate.vue?vue&type=style&index=0&id=f054cf2e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f054cf2e"]])

export default __exports__